import React from 'react';
import './Table.css';

interface TableColumn {
  key: string;
  title: string;
  width?: string;
  align?: 'left' | 'center' | 'right';
  clickable?: boolean;
}

interface TableProps {
  columns: TableColumn[];
  data: Record<string, any>[];
  loading?: boolean;
  emptyMessage?: string;
  onRowClick?: (row: Record<string, any>, index: number) => void;
  onCellClick?: (row: Record<string, any>, columnKey: string) => void;
  className?: string;
}

const Table: React.FC<TableProps> = ({
  columns,
  data,
  loading = false,
  emptyMessage = 'No data available',
  onRowClick,
  onCellClick,
  className = ''
}) => {
  if (loading) {
    return (
      <div className={`table-container ${className}`}>
        <div className="table-loading">Loading...</div>
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className={`table-container ${className}`}>
        <div className="table-empty">{emptyMessage}</div>
      </div>
    );
  }

  return (
    <div className={`table-container ${className}`}>
      <table className="table">
        <thead className="table-header">
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                className={`table-header-cell ${column.align ? `text-${column.align}` : 'text-left'}`}
                style={{ width: column.width }}
              >
                {column.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="table-body">
          {data.map((row, index) => (
            <tr
              key={index}
              className={`table-row ${onRowClick ? 'table-row-clickable' : ''}`}
              onClick={() => onRowClick?.(row, index)}
            >
              {columns.map((column) => (
                <td
                  key={column.key}
                  className={`table-cell ${column.align ? `text-${column.align}` : 'text-left'} ${column.clickable ? 'table-cell-clickable' : ''}`}
                  onClick={column.clickable && onCellClick ? () => onCellClick(row, column.key) : undefined}
                >
                  {row[column.key] || '-'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
